import {Injectable, signal} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '../../../../../../environments/environment';
import {Asset} from '../models/asset.model';
import {SubmitType} from '../../../../shared/models/submit.type';
import {DashboardGroupInfo} from '../models/dashboard-group-info.model';
import {skip} from 'rxjs/operators';
import {TabType} from '../models/tab-type.type';
import {DashboardGroup} from '../models/dashboard-group.model';
import {WelcomeMessageModel} from '../models/welcomeMessage.model';
import { DataSourceExplore } from '../models/dataSource-explore.model';
import { AssetsMetaData, AssetMetaDataPayload } from '../models/assets-meta-data.model';
import { Dashboard } from '../../../../dashboard/models/dashboard';
import { Workspace } from '../../../../shared/models/work-space.model';


@Injectable({
    providedIn: 'root',
})

export class AssetState {
    // loadingHomeMostUsedAssets = false;
    // loadingHomeBookmarkedAssets = false;
    loadingHomeRecentAssets = false;
    loadingHomePaginatedWorkspaces = false;
    loadingNewestDashboardUserAccess = false;
    loadingHomeGroupdashboardAssets = false;

    private allAssets$ = new BehaviorSubject<Asset[]>([]);
    private dashboardAssets$ = new BehaviorSubject<Asset[]>([]);
    private dataSourceAssets$ = new BehaviorSubject<Asset[]>([]);
    private dashboardGroupAssets$ = new BehaviorSubject<Asset[]>([]);

    private prevAllAssets: Asset[] = [];
    private prevDashboardAssets: Asset[] = [];
    private prevDatasourceAssets: Asset[] = [];
    private prevDashboardGroupAssets: Asset[] = [];
    private homeMostUsedAssets$ = new BehaviorSubject<Asset[]>(null);
    private homeBookmarkedAssets$ = new BehaviorSubject<Asset[]>(null);
    private homeRecentAssets$ = new BehaviorSubject<Asset[]>(null);
    private homeDashboardGroupAssets$ = new BehaviorSubject<Asset[]>(null);
    private homePaginatedWorkspacesAssets$ = new BehaviorSubject<Partial<Workspace>[]>(null);
    private newestDashboardUserAccess$ = new BehaviorSubject<Asset[]>(null);
    private loadingHomeAssets$ = new BehaviorSubject<boolean>(false);
    private loadingHomeGroupDashboardAssets$ = new BehaviorSubject<boolean>(false);
    private loadingNewestDashboardUserAccess$ = new BehaviorSubject<boolean>(false);
    private loadingHomeRecentAssets$ = new BehaviorSubject<boolean>(false);
    private loadingHomePaginatedWorkspaces$ = new BehaviorSubject<boolean>(false);
    private prevMostUsedAssets: Asset[] = [];
    private prevRecentAssets: Asset[] = [];
    private prevNewestAssets: Asset[] = [];
    private prevHomeBookmarkedAssets: Asset[] = [];

    private dashboardGroupSelected$ = new BehaviorSubject<DashboardGroupInfo>(null);
    private dashboardsForAddToGroup$ = new BehaviorSubject<Asset[]>(null);
    private dashboardGroupsForMove$ = new BehaviorSubject<DashboardGroup[]>(null);

    private dataSourceList$ = new BehaviorSubject<DataSourceExplore>(null);
     private dashboard$ = new BehaviorSubject<Dashboard>(null);

    private pageNumber$ = new BehaviorSubject<number>(1);
    private totalPages$ = new BehaviorSubject<number>(1);

    private submitting$ = new BehaviorSubject<boolean>(false);
    private submitState$ = new BehaviorSubject<SubmitType>('notSubmitted');

    private welcomeMessage$ = new BehaviorSubject<WelcomeMessageModel>(null);

    private assetsMetaData$ = new BehaviorSubject<AssetsMetaData>(null);
    private assetMetaDataPayload$ = new BehaviorSubject<AssetMetaDataPayload>(null)
    private dashboardNameDuplicated$ = new BehaviorSubject<boolean>(false);
    dashboardNameDuplicated = signal<boolean | null>(false);
  
    get dashboardId(): string {
        return this.dashboard$.getValue().dashboardId;
      }

      get workspaceId(): string {
        return this.dashboard$.getValue().workspaceId;
      }
    updateStateAssets(assets: Asset[], tabType: TabType) {
        this.updateAssetsInfo(assets);
        switch (tabType) {
            case 'All':
                if (assets?.length > 0) {
                    assets.forEach(asset => {
                        asset.cardOptions = [
                            {title: 'حذف', value: 'remove', isPermitted: asset.permissions.get('Remove').isChecked},
                        ];
                    });
                }
                this.allAssets$.next(assets);
                break;
            case 'Dashboard':
                this.dashboardAssets$.next(this.addCardOptionsToAssets(assets));
                break;
            case 'DataSource':
                this.dataSourceAssets$.next(this.addCardOptionsToAssets(assets));
                break;
            case 'DashboardGroup':
                this.dashboardGroupAssets$.next(this.addCardOptionsToAssets(assets));
                break;

        }
    }

    updateAsset(newAsset: any, tabType: TabType) {
        let assetsUpdate;
        switch (tabType) {
            case 'All':
                const currAssets1 = [...this.allAssets$.value];
                this.prevAllAssets = [...this.allAssets$.value];
                assetsUpdate = this.updateItem(currAssets1, newAsset);
                this.allAssets$.next(assetsUpdate);
                break;
            case 'Dashboard':
                const currAssets2 = [...this.dashboardAssets$.value];
                this.prevDashboardAssets = [...this.dashboardAssets$.value];
                assetsUpdate = this.updateItem(currAssets2, newAsset);
                this.dashboardAssets$.next(assetsUpdate);
                break;
            case 'DataSource':
                const currAssets3 = [...this.dataSourceAssets$.value];
                this.prevDatasourceAssets = [...this.dataSourceAssets$.value];
                assetsUpdate = this.updateItem(currAssets3, newAsset);
                this.dataSourceAssets$.next(assetsUpdate);
                break;
            case 'DashboardGroup':
                const currAssets4 = [...this.dashboardGroupAssets$.value];
                this.prevDashboardGroupAssets = [...this.dashboardGroupAssets$.value];
                assetsUpdate = this.updateItem(currAssets4, newAsset);
                this.dashboardGroupAssets$.next(assetsUpdate);
                break;
        }
    }

    updateHomeDashboardGroupAssets(assets: Asset[]) {
      this.homeDashboardGroupAssets$.next(this.addCardOptionsToAssets(assets));
    }

    updateHomeDashboardGroupAsset(asset: Asset) {
      const currentAssets = this.homeDashboardGroupAssets$.getValue();
      console.log(currentAssets);
      const foundIndex = currentAssets.findIndex(tempAsset => asset.assetId === tempAsset.assetId);
      console.log(foundIndex);
      if (foundIndex > -1) {
        currentAssets[foundIndex] = { ...asset };
      }
      this.homeDashboardGroupAssets$.next(currentAssets);
    }

    updateHomeRecentAssets(assets: Asset[]) {
        this.homeRecentAssets$.next(this.addCardOptionsToAssets(assets));
    }

    updateHomeRecentAsset(asset: Asset) {
        this.prevRecentAssets = [...this.homeRecentAssets$.getValue()];
        const currentAssets = this.homeRecentAssets$.getValue();
        const foundIndex = currentAssets.findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        if (foundIndex > -1) {
            currentAssets[foundIndex] = {...asset};
        }
        this.homeRecentAssets$.next(currentAssets);
    }

    updateHomeBookmarkedAssets(assets: Asset[]) {
        this.homeBookmarkedAssets$.next(this.addCardOptionsToAssets(assets));
    }

    updateHomeBookmarkedAsset(asset: Asset) {
        const currentAssets = this.homeBookmarkedAssets$.getValue();
        const foundIndex = currentAssets?.findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        if (foundIndex > -1) {
            currentAssets[foundIndex] = {...asset};
        }
        this.homeBookmarkedAssets$.next(currentAssets);
    }

    updateNewestDashboardUserAccessAssets(assets: Asset[]) {
        this.newestDashboardUserAccess$.next(this.addCardOptionsToAssets(assets));
    }

    updateNewestDashboardUserAccessAsset(asset: Asset) {
        this.prevNewestAssets = [...this.newestDashboardUserAccess$.getValue()];
        const currentAssets = this.newestDashboardUserAccess$.getValue();
        const foundIndex = currentAssets.findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        if (foundIndex > -1) {
            currentAssets[foundIndex] = {...asset};
        }
        this.newestDashboardUserAccess$.next(currentAssets);
    }

    updatePaginatedHomeUserWorkspacesAssets(assets: Partial<Workspace>[]) {
        this.homePaginatedWorkspacesAssets$.next(this.addCardOptionsToAssets(assets));
    }

    updateHomeMostUsedAssets(assets: Asset[]) {
        this.homeMostUsedAssets$.next(this.addCardOptionsToAssets(assets));
    }

    updateHomeMostUsedAsset(asset: Asset) {
        this.prevMostUsedAssets = [...this.homeMostUsedAssets$.getValue()];
        const currentAssets = this.homeMostUsedAssets$.getValue();
        const foundIndex = currentAssets.findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        if (foundIndex > -1) {
            currentAssets[foundIndex] = {...asset};
        }
        this.homeMostUsedAssets$.next(currentAssets);
    }
    getloadingHomeGroupDashboardAssets$(): Observable<boolean> {
        return this.loadingHomeGroupDashboardAssets$.asObservable();
    }

    getLoadingNewestDashboardUserAccess$(): Observable<boolean> {
        return this.loadingNewestDashboardUserAccess$.asObservable();
    }

    getLoadingHomeRecentAssets$(): Observable<boolean> {
        return this.loadingHomeRecentAssets$.asObservable();
    }

    getLoadingHomePaginatedWorkspaces$(): Observable<boolean> {
        return this.loadingHomePaginatedWorkspaces$.asObservable();
    }


    setLoadingNewestDashboardUserAccess(loading: boolean): void {
        this.loadingNewestDashboardUserAccess$.next(loading);
        this.checkHomeAssetsLoaded();
    }

    setLoadingHomeRecentAssets(loading: boolean): void {
        this.loadingHomeRecentAssets$.next(loading);
        this.checkHomeAssetsLoaded();
    }
    setLoadingHomeGroupDashboardAssets(loading: boolean): void {
        this.loadingHomeGroupDashboardAssets$.next(loading);
        this.checkHomeAssetsLoaded();
    }
    setLoadingHomePaginatedWorkspaces(loading: boolean): void {
        this.loadingHomePaginatedWorkspaces$.next(loading);
        this.checkHomeAssetsLoaded();
    }

    setLoadingHomeAssets(loading: boolean): void {
        if(loading) {
            this.loadingHomePaginatedWorkspaces = true;
            this.loadingNewestDashboardUserAccess = true;
            this.loadingHomeGroupdashboardAssets = true;
            this.loadingHomeRecentAssets = true;
        }
        this.loadingHomeAssets$.next(loading);
    }

    getLoadingHomeAssets$(): Observable<boolean> {
        return this.loadingHomeAssets$.asObservable();
    }

    checkHomeAssetsLoaded(): void {
        if(!this.loadingHomeRecentAssets && !this.loadingNewestDashboardUserAccess ) {
            this.setLoadingHomeAssets(false);
        }
    }

    updateDashboardGroupSelected(asset) {
        this.dashboardGroupSelected$.next(asset);
    }

    addDashboardsToDashboardGroup(dashboardIds: string[], pageSize: number, dashboardGroupInfo: DashboardGroupInfo): void {
        const dashboardsForAddToGroup = [...this.dashboardsForAddToGroup$.getValue()];
        const dashboardAssets = [...this.dashboardAssets$.getValue()];
        const totalPages = this.totalPages$.getValue();
        const dashboardIdsLength = dashboardIds.length;
        const dashboardAssetsLength = dashboardAssets.length;
        this.updateTotalPages(
            Math.floor(Math.abs(dashboardIdsLength + dashboardAssetsLength) / pageSize) + totalPages);
        if (dashboardAssetsLength < pageSize) {
            dashboardIds.forEach(dashboardId => {
                const foundedDashboard = dashboardsForAddToGroup.find(dashboard => dashboard.assetId === dashboardId);
                if (foundedDashboard && dashboardAssetsLength < pageSize) {
                    foundedDashboard.dashboardGroupName = dashboardGroupInfo.name;
                    foundedDashboard.dashboardGroupId = dashboardGroupInfo.dashboardGroupId;
                    foundedDashboard.cardOptions = this.getDashboardCardOptions(foundedDashboard);
                    foundedDashboard.imagePath = foundedDashboard.imagePath ?
                      `${environment.api}/File/Download?path=${foundedDashboard.imagePath}` :
                      'assets/images/dashboard-group.png';
                    foundedDashboard.link = `/dashboard/view/${foundedDashboard.workspaceId}/${foundedDashboard.assetId}`;
                    dashboardAssets.push(foundedDashboard);
                }
            });
        }
        this.dashboardAssets$.next(dashboardAssets);
    }

    updateTotalPages(totalPages: number): void {
        this.totalPages$.next(totalPages);
    }

    updatePageNumber(pageNumber: number): void {
        this.pageNumber$.next(pageNumber);
    }

    updateSubmitting(isSubmitting: boolean): void {
        this.submitting$.next(isSubmitting);
    }

    removeBookmarkedAsset(assetType: string, asset: Asset) {
        const updateAllAssets =
            [...this.allAssets$.value].filter((tempAsset: Asset) => tempAsset.assetId !== asset.assetId);
        this.allAssets$.next(updateAllAssets);
        switch (assetType) {
            case 'Dashboard':
                const updateDashboardAssets =
                    [...this.dashboardAssets$.value].filter((tempAsset: Asset) => tempAsset.assetId !== asset.assetId);
                this.dashboardAssets$.next(updateDashboardAssets);
                break;
            case 'DataSource':
                const updateDataSourceAssets =
                    [...this.dataSourceAssets$.value].filter((tempAsset: Asset) => tempAsset.assetId !== asset.assetId);
                this.dataSourceAssets$.next(updateDataSourceAssets);
                break;
            case 'DashboardGroup':
                const updateDashboardGroupAssets =
                    [...this.dashboardGroupAssets$.value].filter((tempAsset: Asset) => tempAsset.assetId !== asset.assetId);
                this.dashboardGroupAssets$.next(updateDashboardGroupAssets);
                break;
            default:
                break;
        }
    }

    removeHomeBookmarkedAsset(asset: Asset) {
        // this.prevMostUsedAssets = [...this.homeMostUsedAssets$.getValue()];

        this.prevRecentAssets = [...this.homeRecentAssets$.getValue()];
        this.prevDashboardGroupAssets = [...this.homeDashboardGroupAssets$.getValue()];
        this.prevNewestAssets = [...this.newestDashboardUserAccess$.getValue()];
        // this.prevHomeBookmarkedAssets = [...this.homeBookmarkedAssets$.getValue()];
        const foundIndexRecent =
            this.homeRecentAssets$.getValue().findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        const foundIndexNewsetGroup =
            this.newestDashboardUserAccess$.getValue().findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        const foundIndexDashboardGroup =
            this.homeDashboardGroupAssets$.getValue().findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        // const foundIndexMostUsed =
        //     this.homeMostUsedAssets$.getValue().findIndex(tempAsset => asset.assetId === tempAsset.assetId);

        // const foundIndexBookmarked =
            // this.homeBookmarkedAssets$.getValue().findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        if (foundIndexRecent > -1) {
            this.homeRecentAssets$.getValue()[foundIndexRecent] = asset;
        }
        if (foundIndexNewsetGroup > -1) {
            this.newestDashboardUserAccess$.getValue()[foundIndexNewsetGroup] = asset;
        }
        if (foundIndexDashboardGroup > -1){
            this.homeDashboardGroupAssets$.getValue()[foundIndexDashboardGroup] = asset;
        }
        // if (foundIndexMostUsed > -1) {
        //     this.homeMostUsedAssets$.getValue()[foundIndexMostUsed] = asset;
        // }
        // if (foundIndexBookmarked > -1) {
        //     this.homeBookmarkedAssets$.getValue().splice(foundIndexBookmarked, 1);
        // }
    }


    addHomeBookmarkedAsset(asset: Asset) {
        this.prevNewestAssets = [...this.newestDashboardUserAccess$.value];
        this.prevRecentAssets = [...this.homeRecentAssets$.value];
        this.prevDashboardGroupAssets = [...this.homeDashboardGroupAssets$.getValue()];
        // this.prevHomeBookmarkedAssets = [...this.homeBookmarkedAssets$.value];
        const foundIndexRecent =
            this.homeRecentAssets$.value.findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        const foundIndexNewsetGroup =
            this.newestDashboardUserAccess$.getValue().findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        const foundIndexDashboardGroup =
            this.homeDashboardGroupAssets$.getValue().findIndex(tempAsset => asset.assetId === tempAsset.assetId);
                    // const foundIndexMostUsed =
        //     this.homeMostUsedAssets$.value.findIndex(tempAsset => asset.assetId === tempAsset.assetId);
        if (foundIndexRecent > -1) {
            this.homeRecentAssets$.value[foundIndexRecent] = asset;
        }
        if (foundIndexNewsetGroup > -1) {
            this.newestDashboardUserAccess$.getValue()[foundIndexNewsetGroup] = asset;
        }
        if (foundIndexDashboardGroup > -1) {
            this.homeDashboardGroupAssets$.getValue()[foundIndexDashboardGroup] = asset;
        }
        // if (foundIndexMostUsed > -1) {
        //     this.homeMostUsedAssets$.value[foundIndexMostUsed] = asset;
        // }
        // if (this.prevHomeBookmarkedAssets.length === 6) {
        //     this.homeBookmarkedAssets$.value.shift();
        //     this.homeBookmarkedAssets$.value.unshift(asset);
        // } else {
        //     this.homeBookmarkedAssets$.value.unshift(asset);
        // }
    }

    updateDashboardsForAddToGroup(dashboards: Asset[]): void {
        this.dashboardsForAddToGroup$.next(dashboards);
    }

    getDashboardsForAddToGroup$(): Observable<Asset[]> {
        return this.dashboardsForAddToGroup$.asObservable().pipe(skip(1));
    }

    updateDashboardGroupsForMove(dashboardGroups: DashboardGroup[]): void {
        this.dashboardGroupsForMove$.next(dashboardGroups);
    }

    getDashboardGroupsForMove$() {
        return this.dashboardGroupsForMove$.asObservable().pipe(skip(1));
    }

    updateDashboardAsset(dashboardGroup: DashboardGroup, dashboardId: string) {
        const currentDashboards = this.dashboardAssets$.getValue();
        const foundedIndex = currentDashboards.findIndex(dashboard => dashboard.assetId === dashboardId);
        if (foundedIndex > -1) {
            currentDashboards[foundedIndex].dashboardGroupId = dashboardGroup.id;
            currentDashboards[foundedIndex].dashboardGroupName = dashboardGroup.name;
            currentDashboards[foundedIndex] = {...currentDashboards[foundedIndex]};
            this.updateAsset(currentDashboards, 'Dashboard');
        }
    }

    getAllAssets$(): Observable<Asset[]> {
        return this.allAssets$.asObservable();
    }

    getDashboardAssets$(): Observable<Asset[]> {
        return this.dashboardAssets$.asObservable();
    }

    getDataSourceAssets$(): Observable<Asset[]> {
        return this.dataSourceAssets$.asObservable();
    }

    getDashboardGroupAssets$(): Observable<Asset[]> {
        return this.dashboardGroupAssets$.asObservable();
    }

    getHomeMostUsedAssets$(): Observable<Asset[]> {
        return this.homeMostUsedAssets$.asObservable().pipe(skip(1));
    }

    getHomeBookmarkedAssets$(): Observable<Asset[]> {
        return this.homeBookmarkedAssets$.asObservable().pipe(skip(1));
    }

    getHomeRecentAssets$(): Observable<Asset[]> {
        return this.homeRecentAssets$.asObservable().pipe(skip(1));
    }

    getHomeDashboardGroupAssets$(): Observable<Asset[]> {
      return this.homeDashboardGroupAssets$.asObservable().pipe(skip(1));
    }
    getPaginatedUserWorkspaces$(): Observable<Partial<Workspace>[]> {
        return this.homePaginatedWorkspacesAssets$.asObservable().pipe(skip(1));
    }
    getNewestDashboardUserAccess$(): Observable<Asset[]> {
        return this.newestDashboardUserAccess$.asObservable().pipe(skip(1));
    }
    getDashboardGroupSelected$(): Observable<DashboardGroupInfo> {
        return this.dashboardGroupSelected$.asObservable();
    }

    getTotalPages$(): Observable<any> {
        return this.totalPages$.asObservable();
    }

    getPageNumber$(): Observable<any> {
        return this.pageNumber$.asObservable();
    }

    getSubmitting$(): Observable<any> {
        return this.submitting$.asObservable();
    }

    rollBackAsset(assetType: TabType) {
        switch (assetType) {
            case 'All':
                this.allAssets$.next(this.prevAllAssets);
                this.prevAllAssets = null;
                break;
            case 'Dashboard':
                this.dashboardAssets$.next(this.prevDashboardAssets);
                this.prevDashboardAssets = null;
                break;
            case 'DataSource':
                this.dataSourceAssets$.next(this.prevDatasourceAssets);
                this.prevDatasourceAssets = null;
                break;
            case 'DashboardGroup':
                this.dashboardGroupAssets$.next(this.prevDashboardGroupAssets);
                this.prevDashboardGroupAssets = null;
                break;
        }
    }

    rollBackRecentAssets() {
        this.homeRecentAssets$.next(this.prevRecentAssets);
        this.prevRecentAssets = [];
    }

    rollBackMostUsedAssets() {
        this.homeMostUsedAssets$.next(this.prevMostUsedAssets);
        this.prevMostUsedAssets = [];
    }

    rollBackBookmarkedAssets() {
        this.homeBookmarkedAssets$.next(this.prevHomeBookmarkedAssets);
        this.prevHomeBookmarkedAssets = [];
    }
    rollBackNewestAssets() {
        this.newestDashboardUserAccess$.next(this.prevNewestAssets);
        this.prevNewestAssets = [];
    }

    rollBackHomeAssets() {
        this.rollBackMostUsedAssets();
        this.rollBackRecentAssets();
        this.rollBackBookmarkedAssets();
        this.rollBackNewestAssets();
    }

    updateItem(assets: Asset[], newAsset: Asset) {
        const result: Asset[] = [];
        assets.forEach((asset) => {
            if (asset.assetId === newAsset.assetId) {
                result.push({...newAsset});
            } else {
                result.push({...asset});
            }
        });
        return [...result];
    }

    updateAssetsInfo(items: Asset[] | Partial<Workspace>[]): void {
        if (items !== null) {
            items.forEach((item: Asset | Partial<Workspace>, index) => {
                // Handle Asset types
                    const asset = item as Asset;
                    if (asset.imagePath !== null && asset.imagePath) {
                        asset.imagePath = `${environment.api}/File/Download?path=${asset.imagePath}`;
                        items[index] = asset;
                    } else {
                        if (asset.assetType === 'Dashboard') {
                            asset.imagePath = 'assets/images/dashboard.png';
                        } else if (asset.assetType === 'DataSource') {
                            asset.imagePath = 'assets/images/datasource.png';
                        } else if (asset.assetType === 'DashboardGroup') {
                            asset.imagePath = 'assets/images/dashboard-group.png';
                        } else if (asset.assetType === 'Workspace') {
                            asset.imagePath = 'assets/images/workspace.png';}
                        items[index] = asset;

                    }

                    if (asset.assetType === 'Dashboard') {
                        asset.link = `/dashboard/view/${asset.workspaceId}/${asset.assetId}`;
                    } else if (asset.assetType === 'DashboardGroup') {
                        asset.link = `/home/dashboardGroup/${asset.workspaceId}/${asset.assetId}`;
                    } else if (asset.assetType === 'DataSource') {
                        asset.link = `/datasource/${asset.workspaceId}/${asset.assetId}`;
                    } else if (asset.assetType === 'Workspace') {
                        asset.link = `/home/${asset.workspaceId}`;
                    }

            });
        }
    }


    setSubmitState(submit: SubmitType): void {
        this.submitState$.next(submit);
    }

    getSubmitState$() {
        return this.submitState$.asObservable();
    }

    setAssetsMetaData(metadata: AssetsMetaData): void {
      this.assetsMetaData$.next(metadata);
    }

    getAssetsMetaData$(): Observable<AssetsMetaData> {
      return this.assetsMetaData$.asObservable();
    }

    setAssetMetaDataPayload(metaDataPayload: AssetMetaDataPayload): void {
        this.assetMetaDataPayload$.next(metaDataPayload)
    }

    getAssetMetaDataPayload(): AssetMetaDataPayload {
        return this.assetMetaDataPayload$.value
    }

    getWelcomeMessage$(): Observable<WelcomeMessageModel> {
        return this.welcomeMessage$.asObservable();
    }

    setWelcomeMessage(welcomeMessage: WelcomeMessageModel) {
        this.welcomeMessage$.next(welcomeMessage);
    }

    addCardOptionsToAssets(assets: Asset[] | Partial<Workspace>[]): any[] {
        if (assets?.length > 0) {
            assets.forEach(asset => {
                // Check if this is an Asset type with assetType property
                if ('assetType' in asset) {
                    switch (asset.assetType) {
                        case 'Dashboard':
                            asset.cardOptions = this.getDashboardCardOptions(asset as Asset);
                            break;
                        case 'DashboardGroup':
                            asset.cardOptions = this.getDashboardGroupCardOptions(asset as Asset);
                            break;
                        case 'DataSource':
                            asset.cardOptions = this.getDataSourceCardOptions(asset as Asset);
                            break;
                        case 'Workspace':
                            asset.cardOptions = this.getWorkspaceCardOptions(asset as Partial<Workspace>);
                            break;
                    }
                }
            });
        }
        return assets;
    }

    getDashboardCardOptions(asset: Asset): any {
        if (!asset.inactive) {
            return [
                {title: 'ویرایش', value: 'dashboardEdit', isPermitted: asset.permissions.get('Edit').isChecked},
                {
                    title: 'انتقال به',
                    value: 'dashboardMovement',
                    isPermitted: asset.permissions.get('Movement').isChecked,
                },
                {title: 'تکرار', value: 'dashboardDuplicate', isPermitted: asset.permissions.get('Edit').isChecked},
                {
                    title: 'مجوزها',
                    value: 'dashboardPermissions',
                    isPermitted: asset.permissions.get('Permissions').isChecked,
                },
                {title: 'تغییر نام', value: 'dashboardEditName', isPermitted: asset.permissions.get('Edit').isChecked},
                // {
                //     title: 'غیر فعال', value: 'dashboardDeactivate',
                //     isPermitted: asset.permissions.get('Activate/Deactivate').isChecked,
                // },
                {
                    title: 'تغییر عکس',
                    value: 'dashboardUploadImage',
                    isPermitted: asset.permissions.get('Edit').isChecked,
                },
                {
                    title: 'حذف عکس',
                    value: 'dashboardRemoveImage',
                    isPermitted: asset.permissions.get('Edit').isChecked,
                },
                {title: 'حذف', value: 'dashboardRemove', isPermitted: asset.permissions.get('Remove').isChecked},
                {
                    title: 'تاریخچه داشبورد',
                    value: 'dashboardHistory',
                    isPermitted: asset.permissions.get('Edit').isChecked,
                },
                {
                    title: 'خروجی گرفتن',
                    value: 'exportDashboard',
                    isPermitted: asset.permissions.get('Edit').isChecked,
                },
            ];
        } else {
            return [
                {
                    title: 'فعال',
                    value: 'dashboardActivate',
                    isPermitted: asset.permissions.get('Activate/Deactivate').isChecked,
                },
            ];
        }
    }

    getDashboardGroupCardOptions(asset: Asset): any {
        return [
            {title: 'تغییر نام', value: 'dashboardGroupEditName', isPermitted: asset.permissions.get('Edit').isChecked},
            {
                title: 'مجوزها',
                value: 'dashboardGroupPermissions',
                isPermitted: asset.permissions.get('Permissions').isChecked,
            },
            {
                title: 'تغییر عکس',
                value: 'dashboardGroupUploadImage',
                isPermitted: asset.permissions.get('Edit').isChecked,
            },
            {
                title: 'حذف عکس',
                value: 'dashboardGroupRemoveImage',
                isPermitted: asset.permissions.get('Edit').isChecked,
            },
            {title: 'حذف', value: 'dashboardGroupRemove', isPermitted: asset.permissions.get('Remove').isChecked},
        ];
    }

    getDataSourceCardOptions(asset: Asset): any {
        return [
            {
                title: 'داشبورد جدید', value: 'dataSourceCreateDashboard',
                isPermitted: asset.permissions.get('CreateDashboard').isChecked,
            },
            {
                title: 'مجوزها',
                value: 'dataSourcePermissions',
                isPermitted: asset.permissions.get('Permissions').isChecked,
            },
            // {
            //     title: 'اکنون به‌روزرسانی شود', value: 'dataSourceSchedule',
            //     isPermitted: asset.dbConnectionType === 'MicrosoftSQLServer' || asset.dbConnectionType === 'oracle',
            // },
            {title: 'تغییر نام', value: 'dataSourceEditName', isPermitted: asset.permissions.get('Edit').isChecked},
            // {title: 'تغییر عکس', value: 'dataSourceUploadImage', isPermitted: asset.permissions.get('Edit').isChecked},
            // {title: 'حذف عکس', value: 'dataSourceRemoveImage', isPermitted: asset.permissions.get('Edit').isChecked},
            {title: 'تکرار منبع داده', value: 'dataSourceCopy', isPermitted: (asset.permissions.get('Edit').isChecked && (asset.dbConnectionType !== 'WebService'))},
            {title: 'حذف', value: 'dataSourceRemove', isPermitted: asset.permissions.get('Remove').isChecked},
        ];
    }
    getWorkspaceCardOptions(workspace: Partial<Workspace>): any {
        return [
          { title: 'تغییر نام', value: 'workspaceEditName', isPermitted: true },
          { title: 'افزودن عکس', value: 'workspaceUploadImage', isPermitted: workspace.imagePath === null },
          { title: 'تغییر عکس', value: 'workspaceUploadImage', isPermitted: workspace.imagePath !== null },
          { title: 'حذف عکس', value: 'workspaceRemoveImage', isPermitted: workspace.imagePath !== null },
          { title: 'سنجاق کردن', value: 'workspacePinStatus', isPermitted: !workspace.isPined },
          { title: 'برداشتن سنجاق', value: 'workspacePinStatus', isPermitted: workspace.isPined },
        ];
      }
  setDataSourceList(dataSourceList: DataSourceExplore): void {
    this.dataSourceList$.next(dataSourceList);
  }

  updateDataSourceList(dataSourceList: DataSourceExplore): void {
    const prevDataSourceList = this.dataSourceList$.getValue();
    const newDataSourceList: DataSourceExplore = {
      totalCount: dataSourceList.totalCount,
      totalPages: dataSourceList.totalPages,
      pageData: [...prevDataSourceList.pageData, ...dataSourceList.pageData],
    };
    this.dataSourceList$.next(newDataSourceList);
  }

  getDatasourceList$(): Observable<DataSourceExplore> {
    return this.dataSourceList$.asObservable().pipe(skip(1));
  }
  setDashboardNameDuplicated(value:boolean){
    this.dashboardNameDuplicated.set(value)
  }
}
